import React from 'react';
import QRCode from 'react-qr-code';
import { systemCode, xs_languageCode } from '../../..';
import { convertToDecimalWithPrecision, getBarcode, getBarcodeIdTicket, getConfiguration, getCurrencyValue, getHiddenTicket, getPrintableAmount, oddToString, truncateDoubleTo } from '../../../data/utils';
import { getLabel } from '../../../data/labels';
import { getTaxPercentage, taxesEnabled } from '../../purchase-service';

function PlainTicketFooter(props) {
	
	const ticketData = props.ticketData;
	const conf = getConfiguration();
	const frontendType = props.frontendType;
	const aamsEnviroment = props.aamsEnviroment; // TODO: add "isEstero" in configuration if "nationsAsSkin" wont be enough. In Italy no way to have two different currencies at the moment ;)
	const printAgainTerminalRec = props.printAgainTerminalRec;
	const printableTotalAmount = getCurrencyValue(ticketData.amount, conf.cs.m, conf.cs.nd, conf.cs.ct);
	const terminalCopy = props.terminalCopy;
	const bonus = ticketData.bonus;
	const totalWin = ticketData.win;
	const skinProperties = props.skinProperties;

	const printableBonus = getCurrencyValue(bonus, conf.cs.m, conf.cs.nd, conf.cs.ct);
	const winningNoBonus = getCurrencyValue(totalWin - bonus, conf.cs.m, conf.cs.nd, conf.cs.ct);
	const printableTotalWin = getCurrencyValue(totalWin, conf.cs.m, conf.cs.nd, conf.cs.ct);
	const maxWinAmount = getCurrencyValue(5000000, conf.cs.m, conf.cs.nd, conf.cs.ct);
	let totalCentOdd = 100;
	if(ticketData.purchaseType !== 'systembets'){
		let totalOdd = 1;
		for(let k in ticketData.events){
			let selection = ticketData.events[k];
			for(let kb in selection.bets){
				let bet = selection.bets[kb];
				totalOdd = totalOdd * convertToDecimalWithPrecision(bet.odd, 19, 6)/100;
				totalOdd = convertToDecimalWithPrecision(totalOdd, 19, 6);
			}
		}
		totalOdd = truncateDoubleTo(totalOdd, 2) + "";
		totalOdd = totalOdd.replace(/,/g, '');
		totalOdd = totalOdd.replace(/\./g, '');
		totalCentOdd = parseInt(totalOdd);
	}

	
	const printableOdd = oddToString(totalCentOdd);
	
	
	let bonusType = '';
	if(bonus > 0){
		bonusType = ticketData.purchaseType !== 'systembets'? 'B9' : 'B10';
	}
	
	
	const clearBoth = {clear: "both"};
	
	
	let idTicketToShow = ticketData.idTicket;
	if(terminalCopy && skinProperties && skinProperties.hideTerminalTicket){
		idTicketToShow = getHiddenTicket(idTicketToShow);
	}
	
	
	function generateIdTicketWithBars(idTicket){
		let res = '';
		let tokens = idTicket.match(/.{1,4}/g);
		res = tokens.join("-");
		return res;
	}
	let linkTemplate = conf.qrct;
	const showQRCode = frontendType === 'ONLINE' || (!terminalCopy || (terminalCopy && !conf.rs.otid));
	
	if(linkTemplate != null && linkTemplate.length > 0){
		// show the qr code always if we are online, and always if it is the official receipt. If it is a copy, then otid must be false -> ticket id can be taken from qrcode)
		if(showQRCode){
			linkTemplate= linkTemplate.replace(/{{TICKET}}/g, ticketData.idTicket);
			linkTemplate = linkTemplate.replace(/{{LANG}}/g, xs_languageCode);
			linkTemplate = linkTemplate.replace(/{{SYSTEM_CODE}}/g, systemCode);
			//htmlQrCode = getQrCode(linkTemplate);
		}
	}
	
	// this char will be added to the string "ID" (it means identify string of the ticket) to make clear that this receipt has been
	// print again due to technical issues.
	let charPAR = '';
	if(printAgainTerminalRec){
		let idString = getLabel('printer.plain_ticket.header.id');
		idString = (idString == null || idString === '')? 'IB' : idString;
		charPAR = idString.charAt(idString.length - 1);	
	}
	
	const promoMessage = window.getPromoMessageLS? window.getPromoMessageLS() : null;
	
	let totalAmountLabel = null;
	
	if(ticketData.purchaseType !== 'systembets'){
		totalAmountLabel = getLabel('printer.plain_ticket.footer.total_amount');
	}
	else{
		totalAmountLabel = getLabel('printer.plain_ticket.footer.system_total_amount');
	}
	
	let totalAmountLabelTaxedStake = null;
	let grossTotalAmount = null;
	let showStakeTaxed = false;
	if(ticketData.taxOnStake && ticketData.taxOnStake > 0){
		totalAmountLabelTaxedStake = getLabel('ticket.general.taxed_stake');
		totalAmountLabelTaxedStake = totalAmountLabelTaxedStake.replace(/{{PERCENTAGE}}/g, (conf.cs.tb / 100 + '%') );
		grossTotalAmount = ticketData.taxOnStake + ticketData.amount;
		grossTotalAmount = getCurrencyValue(grossTotalAmount, conf.cs.m, conf.cs.nd, conf.cs.ct);
		showStakeTaxed = true;
	}


	let taxesAdviceSystem = null;
	if(ticketData.purchaseType === 'systembets' && getLabel('ticket.system.advice_taxes') && taxesEnabled()){
		taxesAdviceSystem = getLabel('ticket.system.advice_taxes');
		taxesAdviceSystem = taxesAdviceSystem.replace(/{{TAXES_AMOUNT}}/g, getTaxPercentage());
	}
	
	let printBarcode = false;
	if(conf.tad?.bob){
		// ticket must be printed in the footer
		if(!terminalCopy){
			printBarcode = frontendType === 'TERMINAL' || frontendType === 'SELF-CASHIER';
		}
	}

	return <>
		<div className='separator'></div>
		<div className="bold">
			<div className="left td-60">{totalAmountLabel}:</div>
			<div className="right td-40 textright">{grossTotalAmount != null? grossTotalAmount : printableTotalAmount}</div>
			<div style={clearBoth}></div>
		</div>
		{
			 showStakeTaxed && (
				<div className="bold">
					<div className="left td-60">{totalAmountLabelTaxedStake}:</div>
					<div className="right td-40 textright">{printableTotalAmount}</div>
					<div style={clearBoth}></div>
				</div>
			)
		}
		{
			ticketData.purchaseType === 'systembets' && aamsEnviroment && (
				<div >
					<div className="left td-60">{getLabel('printer.plain_ticket.footer.winnings_limit')}</div>
					<div className="right td-40 textright">{maxWinAmount}</div>
					<div style={clearBoth}></div>
				</div>
			)
		}
		{
			ticketData.purchaseType === 'systembets' &&(
					<div className="textcenter id_ticket_footer">{getLabel('printer.plain_ticket.header.id') + charPAR}: {generateIdTicketWithBars(idTicketToShow)}</div>
			)
		}
		
		{
			ticketData.purchaseType !== 'systembets' && (
				<div>
					<div className="left td-60">{getLabel('printer.plain_ticket.footer.total_odds')}</div>
					<div className="right td-40 textright">{printableOdd}</div>
					<div style={clearBoth}></div>
				</div>
			)
		}
		{
				ticketData.taxes > 0 &&  <>
					<div className="totale_importo_multipla">
						<div className="left td-60">{getLabel('printer.plain_ticket.footer.gross_winnings')}</div>
						<div className="right td-40 textright">{getCurrencyValue(ticketData.winPlusTaxes, conf.cs.m, conf.cs.nd, conf.cs.ct)}</div>
						<div style={clearBoth}></div>
					</div>
					<div className="totale_importo_multipla">
						<div className="left td-60">{getLabel('printer.plain_ticket.footer.tax')} {'(' + getTaxPercentage() + ')'}</div>
						<div className="right td-40 textright">{getCurrencyValue(ticketData.taxes, conf.cs.m, conf.cs.nd, conf.cs.ct)}</div>
						<div style={clearBoth}></div>
					</div>
				</>
		}

		{
			(ticketData.purchaseType !== 'systembets' && bonus > 0) && <>
				<div>
					<div className="left td-60">{getLabel('printer.plain_ticket.footer.potential_winnings')}</div>
					<div className="right td-40 textright">{winningNoBonus}</div>
					<div style={clearBoth}></div>
				</div>
				<div>
					<div className="left td-60">{getLabel('printer.plain_ticket.footer.bonus')}</div>
					<div className="right td-40 textright">{printableBonus}</div>
					<div style={clearBoth}></div>
				</div>

			</>
		}
		{
			bonusType.length > 0 &&(
				<div>
					<div className="left td-60">{getLabel('printer.plain_ticket.footer.bonus_type')}</div>
					<div className="right td-40 textright">{bonusType}</div>
					<div style={clearBoth}></div>
				</div>		
			)
		}


		{
			ticketData.purchaseType !== 'systembets'?
			<>
				<div className="textcenter total_win_text">{getLabel('printer.plain_ticket.footer.total_winnings')}</div>
				<div className="textcenter total_win">{printableTotalWin}</div>
			</>
			:
			<>
				<div className="separator"></div>
				<table className="combinations">
					<tr>
						<td className="textleft">{getLabel('printer.plain_ticket.footer.type')}</td>
						<td className="textright">{getLabel('printer.plain_ticket.footer.combs')}</td>
						<td className="textright">{getLabel('printer.plain_ticket.footer.bet_amount')}</td>
						<td className="textright">{getLabel('printer.plain_ticket.footer.min_winnings')}</td>
						<td className="textright">{getLabel('printer.plain_ticket.footer.max_winnings')}</td>
					</tr>
					{
						ticketData.tuples.map(function(tupla){
							const reactKey = 'tupla-' + tupla.id;
							return(
								<tr key={reactKey} className="npla">
									<td className="textleft">{tupla.id}{getLabel('betslip.pla')}</td>
									<td className="textright">{tupla.combs}</td>
									<td className="textright">{getPrintableAmount(tupla.amount, conf.cs.m, conf.cs.nd)}</td>
									<td className="textright">{getPrintableAmount(tupla.vMin, conf.cs.m, conf.cs.nd)}</td>
									<td className="textright">{getPrintableAmount(tupla.vMax, conf.cs.m, conf.cs.nd)}</td>
								</tr>
							)
						})
					}
				</table>
			
				<div className="">
				<div className="left td-60">{getLabel('printer.plain_ticket.footer.total_combs')}</div>
				<div className="right td-40 textright">{ticketData.totCombs}</div>
				<div style={clearBoth}></div>
				</div>
				<div className="">
					<div className="left td-60">{getLabel('printer.plain_ticket.footer.total_potential_winnings')}</div>
					<div className="right td-40 textright">{printableTotalWin}</div>
					<div style={clearBoth}></div>
				</div>
			</>
		}

		{
			ticketData.purchaseType !== 'systembets' &&(
				<div className="textcenter id_ticket_footer">{getLabel('printer.plain_ticket.header.id') + charPAR}: {generateIdTicketWithBars(idTicketToShow)}</div>			
			)
		}
		
		
		<div className="separator"></div>
		
		{
			taxesAdviceSystem && (
				<div className="textcenter bold">{taxesAdviceSystem}</div>
			)
		}
		
		{
				showQRCode && linkTemplate.length > 0 &&(
					<div className="qrcode-container" >
						<QRCode value={linkTemplate} size={90}  style={{"marginTop":'1%', "marginBottom":'1%'}} />
					</div>	
				)
		}
			
		{
		printBarcode && <div className="barcode-top"> 
 			<img style={{ height: "50px", width:"100%"}} src={getBarcode(getBarcodeIdTicket(ticketData.idTicket, printAgainTerminalRec), 1, false)} />
 		</div>
		}
		{
			(frontendType === 'ONLINE' || props.terminalCopy) && <>
				<div className="center disclaimer_spacing website">{conf.url}</div>			
				{
					aamsEnviroment &&(
							<div className="center disclaimer_spacing bold">
								La registrazione e l'esito della puntata effettuata possono essere verificati sul sito www.aams.it.
								<br/>
								Questo promemoria non è una ricevuta di gioco valida per la riscossione della vincita.
							</div>
					)
				}
			</>
		}
		{
			aamsEnviroment &&(
				<div className="center disclaimer_spacing bold">
					Il gioco può causare dipendenza.
					<br/>
					Consulta le probabilità di vincita su www.aams.gov.it
					<br/>
					E' vietato il gioco ai minori di anni 18
				</div>
			)
		}
		{
			promoMessage && (
					<div className="center disclaimer_spacing bold" style={{ marginTop : "2px", fontSize:"13px"}}>{promoMessage}</div>
			)
		}
		{
			conf.tad?.fad?.[xs_languageCode] && <div className="center disclaimer_spacing bold" style={{ marginTop : "5px"}}>
				{conf.tad.fad[xs_languageCode]}
			</div>
		}
		{/* ****************************************************************************************************************************************   
			On environments where the payment of ticket can be done on physical self (conf.rs.paysc is true ), the imprinter needs enough whitespace at the bottom of the printed ticket.
			IMPORTANT: to ensure that a whitespace is rendered on the bottom edge, this content should always be placed at the end of this component.
			To make sure that the whitespace is printend when calling window.print(), we render a <div> containing a '.' with a font size of 1px 
		*/
			conf?.rs?.paysc && <div style={{ marginTop : "35px", fontSize: "1px"}}>.</div>
		}
	</>
}

export default PlainTicketFooter;